<template>
  <div class="container">
    <!-- 优势特点 -->
    <div class="row">
      <div class="item col-12 col-sm-6 my-flex my-col-top" v-for="(item,index) in dataList.filter(m=>m.type=='Feature')" :key="index">
        <div class="my-m-r-10">
          <img v-if="item.imageUrl" :src="item.imageUrl" width="80px" height="80px" />
        </div>
        <div class="my-flex-1 my-text-left">
          <div class="title my-m-r-10 my-line-1" style="font-size: 24px;">{{ item.title }}</div>
          <div class="desc my-font-sm my-type-info">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'aos/dist/aos.css'
import AOS from 'aos/dist/aos.js'

export default {
  props: {
    dataList: {
      type: Array,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      // mHref: ''
    }
  },
  watch: {},
  methods: {},
  computed: {
    ...mapGetters(['softPrice'])
  },
  mounted() {},
  created() {
    // this.utils.refreshSoftPrice(this.onloadArgs.getInvite())
    // this.mHref = this.gSetting.product.swiperList[0].buttons[0].href
    AOS.init({
      offset: 100,
      duration: 300,
      easing: 'ease-in-sine'
    })
  }
}
</script>

<style lang="scss" scoped>
/* 手机版 */
@media screen and (max-width: 576px) {
  .item {
    .title {
      font-weight: 400 !important;
      font-size: 20px !important;
      padding-top: 5px !important;
      margin-bottom: 5px !important;
    }

    .desc {
      font-size: 12px !important;
      line-height: 120% !important;
      margin-bottom: 5px !important;
    }
  }
}

/* 电脑版 */
.item {
  padding: 10px;
}
.item:hover {
  background-color: #fff;
}
</style>